import { AppState } from '../../../types/store';

export const userSelector = (state: AppState) => state.user;
export const userPickupLocationsSelector = (state: AppState) => state.user.pickupLocations;
export const galileoVarsSelector = (state: AppState) => state.user.userGalileoVars;
